import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../material.module';
import { HeaderComponent } from './components/header/header.component';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
import { SearchItemComponent } from './components/search-item/search-item.component';
import { ChipComponent } from './components/chip/chip.component';
import { ButtonComponent } from './components/button/button.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { FilterModalComponent } from './components/modals/filter-modal/filter-modal.component';
import { GoogleMapComponent } from './components/google-map/google-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FooterComponent } from './components/footer/footer.component';
import { ServicesComponent } from './components/services/services.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestConsultationComponent } from './components/request-consultation/request-consultation.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { IdentifyUserModalComponent } from './components/modals/identify-user-modal/identify-user-modal.component';
import { InfoModalComponent } from './components/modals/info-modal/info-modal.component';
import { TreeComponent } from './components/tree/tree.component';
import { GoogleMapSearchBoxComponent } from './components/google-map-search-box/google-map-search-box.component';
import { InfoCopyComponent } from './components/info-copy/info-copy.component';
import { DownloadMedicalGuideComponent } from './components/modals/download-medical-guide/download-medical-guide.component';
import { DownloadPdfCardComponent } from './components/download-pdf-card/download-pdf-card.component';
import { MedicalGuideFeatureComponent } from './components/medical-guide-feature-table/medical-guide-feature.component';
import { DotSliderComponent } from './components/dot-slider/dot-slider.component';
import { ErrorServerComponent } from './components/modals/error-server/error-server.component';
import { DownloadPDFLinkComponent } from './components/download-pdf-link/download-pdf-link.component';
import { TrimDirective } from "./directives/trim.directive";
import { ErrorIdentifyUserModalComponent } from './components/modals/error-identify-user-modal/error-identify-user-modal.component';
import { FullFooterComponent } from './components/full-footer/full-footer.component';

const COMPONENTS = [
  HeaderComponent,
  HeaderSearchComponent,
  SearchItemComponent,
  ChipComponent,
  ButtonComponent,
  CardInfoComponent,
  FilterModalComponent,
  GoogleMapComponent,
  HeaderComponent,
  FooterComponent,
  FullFooterComponent,
  ServicesComponent,
  RequestConsultationComponent,
  BreadcrumbsComponent,
  IdentifyUserModalComponent,
  InfoModalComponent,
  GoogleMapSearchBoxComponent,
  TreeComponent,
  InfoCopyComponent,
  DownloadMedicalGuideComponent,
  ErrorIdentifyUserModalComponent,
  DownloadPdfCardComponent,
  MedicalGuideFeatureComponent,
  DotSliderComponent,
  ErrorServerComponent,
  DownloadPDFLinkComponent,
  TrimDirective
];

const DECLARATIONS: any[] = [...COMPONENTS];

@NgModule({
  declarations: [
    ...DECLARATIONS
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    GoogleMapsModule,
    ReactiveFormsModule,
    FormsModule,
    SwiperModule,
    MaterialModule,
  ],
  exports: [
    CommonModule,
    SwiperModule,
    TranslateModule,
    MaterialModule,
    ...DECLARATIONS,
  ],
  providers: [TitleCasePipe],
})
export class SharedModule { }
